import {
  isSafeNavigationHref,
  readWorkspaceBashNavigation,
} from '@/components/chat/tool-calls/workspace-bash-navigation';

/** The server has saved the link before this tab applies the navigation. */
export function deliverRealtimeVoiceNavigation(args: {
  navigation: unknown;
  origin: string;
  push: (href: string) => void;
  openExternal: (href: string) => boolean;
}): 'opened' | 'blocked' | 'invalid' {
  const navigation = readWorkspaceBashNavigation({
    data: { exitCode: 0, navigation: args.navigation },
  });
  if (!navigation || !isSafeNavigationHref(navigation.href)) return 'invalid';
  const url = new URL(navigation.href, args.origin);
  if (url.origin === args.origin) {
    args.push(`${url.pathname}${url.search}${url.hash}`);
    return 'opened';
  }
  // Keep the persistent call on the workspace tab when opening another site.
  return args.openExternal(url.href) ? 'opened' : 'blocked';
}
